import React, { useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import {
  AddButton,
  Badge,
  DefaultButton,
  DropdownAddButton,
} from "../../components/micro/input";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import Tab from "../../components/common/Tab";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customTable/CustomTable";
import { History, SortDownArrow } from "../../assets/svg";
import Action from "../../components/common/Action";
import ServicesLeftModal from "./ServicesLeftModal";
import ContractPreviewModal from "./ContractPreviewModal";

const BulkOption = [
  { id: 1, value: "pushedtoSales", label: "Pushed to Sales" },
  { id: 2, value: "archive", label: "Archive" },
];
const Status = [
  { id: 1, value: "pushed", label: "Pushed" },
  { id: 2, value: "pending", label: "Pending" },
  { id: 3, value: "failed", label: "Failed" },
];
const DateRange = [
  { id: 1, value: "1", label: "1 Month" },
  { id: 2, value: "2", label: "2 Months" },
  { id: 3, value: "3", label: "3 Months" },
  { id: 4, value: "4", label: "4 Months" },
  { id: 6, value: "6", label: "6 Months" },
  { id: 12, value: "12", label: "12 Months" },
];

const mockData = [
  {
    no: 1,
    company_name: "ABC Corp",
    service: "20",
    leftService: "6",
    date: "21/01/2024 -21/01/2024",
    frequency: "1 month",
    status: "pending",
    history: <History />,
  },
  {
    no: 2,
    company_name: "XYZ Ltd",
    service: "30",
    leftService: "9",
    date: "21/01/2024 -21/01/2024",
    frequency: "6 months",
    status: "failed",
    history: "-",
  },
  {
    no: 3,
    company_name: "XYZ Ltd",
    service: "15",
    leftService: "3",
    date: "21/01/2024 -21/01/2024",
    frequency: "3 months",
    status: "completed",
    history: "-",
  },
  {
    no: 4,
    company_name: "XYZ Ltd",
    service: "21",
    leftService: "21",
    date: "21/01/2024 -21/01/2024",
    frequency: "12 months",
    status: "pushed",
    history: "-",
  },
  {
    no: 5,
    company_name: "XYZ Ltd",
    service: "10",
    leftService: "5",
    date: "21/01/2024 -21/01/2024",
    frequency: "2 months",
    status: "pushed",
    history: "-",
  },
];

const Recurring = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [activeTab, setActiveTab] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const navigate = useNavigate();

  const tabs = [
    { label: "Active" },
    { label: "Completed" },
    { label: "Archived" },
  ];

  const handleTabClick = (label) => {
    setActiveTab(label);
  };

  const getFilteredData = () => {
    if (activeTab === "All") {
      return mockData;
    }

    return mockData.filter((item) => activeTab === item.status);
  };

  const filteredData = getFilteredData();

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <div className="flex items-center">
            <input type="checkbox" className="w-4 h-4 mr-2 accent-themeBtn" />
            <span>No.</span>
          </div>

          <SortDownArrow className="ml-1 transition-transform duration-300 " />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Company</span>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <span>Total Services</span>
          <SortDownArrow className="ml-1 transition-transform duration-300 " />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <span>Services Left</span>
          <SortDownArrow className="ml-1 transition-transform duration-300 " />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <span>Start/End Date</span>
          <SortDownArrow className="ml-1 transition-transform duration-300 " />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Frequency</span>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start"
      >
        <span>Status </span>
      </th>
      <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
        Version History
      </th>
      <th className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {filteredData.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-5 py-3">
            <div className="flex items-center">
              <input
                type="checkbox"
                id={`checkbox-${index}`}
                className="w-4 h-4 mr-2 accent-themeBtn"
              />
              {element.no}
            </div>
          </td>
          <td className="px-5 py-3">{element.company_name}</td>
          <td className="px-5 py-3">{element.service}</td>
          <td className="px-5 py-3">
            <button
              className="text-themeBtn border-b w-3 text-center h-4"
              onClick={() => setIsModalOpen(true)}
            >
              {element.leftService}
            </button>
          </td>
          <td className="px-5 py-3">{element.date}</td>
          <td className="px-5 py-3">{element.frequency}</td>
          <td className="px-5 py-3">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  element.status === "pushed"
                    ? "border-borderGreen text-bgGreen !text-xs"
                    : element.status === "completed"
                    ? "border-borderGreen text-bgGreen"
                    : element.status === "failed"
                    ? "border-borderRed text-red"
                    : element.status === "pending"
                    ? "border-borderGrey text-black"
                    : ""
                }`}
                value={
                  element.status === "pushed"
                    ? "Pushed"
                    : element.status === "failed"
                    ? "Failed"
                    : element.status === "completed"
                    ? "Completed"
                    : element.status === "pending"
                    ? "Pending"
                    : ""
                }
              />
            </div>
          </td>
          <td className="px-5 py-3 ">
            <button
              onClick={() => {
                setShowConfirmationModal(true);
              }}
            >
              {element.history}
            </button>
          </td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => navigate("/contract-preview")}
                  >
                    View/Edit
                  </li>
                  <li className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer">
                    Duplicate
                  </li>
                  <li className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer">
                    Pushed to Quotation
                  </li>
                  <li className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer">
                    Archive
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  const handleDropdownSelect = (option) => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Recurring Contract
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Recurring Contract"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          <div>
            <AddButton
              value="Add Contract"
              onClick={() =>
                navigate("/create-edit-recurring", {
                  state: { mode: "create" },
                })
              }
            />
          </div>

          {isModalOpen && (
            <ServicesLeftModal
              key="modal"
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
        <div>
          <Tab
            tabs={tabs.map((tab) => ({
              label: tab.label,
              onClick: () => handleTabClick(tab.label),
              isActive: activeTab === tab.label,
            }))}
            btnClass="w-full font-normal mb-5 h-full text-textSecondary"
            btnDivClass="px-2 pt-4 py-2"
          />
        </div>
        <div className="flex items-center space-x-3">
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="option"
            placeholder="Bulk Option"
            options={BulkOption}
            isClearable={true}
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="status"
            placeholder="Status"
            options={Status}
            isClearable={true}
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedStatus ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="date"
            placeholder="Date Range"
            options={DateRange}
            isClearable={true}
            value={selectedDate}
            onChange={(e) => {
              setSelectedDate(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedDate ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        <div className="w-full bg-white shadow rounded-lg mt-5 ">
          <CustomTable
            overflowVisibleLg={true}
            columnHeaders={<ColumnHeaders />}
            dataRows={<DataRows />}
            data={mockData}
            loading={false}
            showPagination={true}
            setPaginationCurrentLimit={setPageLimit}
            paginationCurrentLimit={pageLimit}
            current={pageCount}
            paginationData={(crPage) => setPageCount(crPage)}
          />
        </div>
      </div>
      {showConfirmationModal && (
        <ContractPreviewModal
          onClose={() => setShowConfirmationModal(false)}
          type={"History"}
          modal={"true"}
        />
      )}
    </>
  );
};

export default Recurring;
